export default __webpack_public_path__ + "static/4_29-b2321f8d0befd873b83d1f8f1cced5a4.png";